// extracted by css-extract-rspack-plugin
export default {"SharedMarkdownContent":"DirectoryRichtextContent-module__SharedMarkdownContent__hHXUL"};